import { ImporterOfRecordDetails, ImporterOfRecord } from './ImporterOfRecordDetails';
import { Text } from '@nike/eds';
import GraphQLService from '../../shared/GraphQLService';
import useSWR from 'swr';

const api = new GraphQLService();

const useImportersApi = () => {
  const fetcher = async () => await api.getImportersOfRecord();
  return useSWR('getImportersOfRecord', fetcher, { refreshInterval: 360000 });
};

export function ImportersOfRecord() {
  const { data, isLoading, error } = useImportersApi();

  return (
    <div className="eds-spacing--mb-24">
      <Text
        className="eds-spacing--mb-8"
        font={'title-3'}
        as={'h2'}
      >
        Importers of Record
      </Text>
      {isLoading && <Text>Loading importers of record...</Text>}
      {error && <div style={{ color: 'red' }}>Error: {error.message}</div>}
      <div className="eds-flex eds-gap--16 ">
        {(data?.data?.getImportersOfRecord?.items || []).map(
            (importer: ImporterOfRecord, index: number) => (
              <ImporterOfRecordDetails key={index} importer={importer} />
            )
          )}
      </div>
    </div>
  );
}